<template>
  <div id="app">
    <Spinner />
    <Topbar />
    <Navbar />
    <router-view />
    <!-- Newsletter commented out - may be used later -->
    <!-- <Newsletter /> -->
    <Footer />
    <BackToTop />
    <VideoModal />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Topbar from './components/Topbar.vue'
import Navbar from './components/Navbar.vue'
import Footer from './components/FooterView.vue'
import Spinner from './components/Spinner.vue'
import BackToTop from './components/BackToTop.vue'
import VideoModal from './components/VideoModal.vue'
// import Newsletter from './components/Newsletter.vue'

export default defineComponent({
  name: 'App',
  components: {
    Topbar,
    Navbar,
    Footer,
    Spinner,
    BackToTop,
    VideoModal
    // Newsletter
  }
})
</script>

<style>
#app {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
